const getStyles = () => {
  return {
    // Section wrapper
    section: {
      position: 'relative',
      overflow: 'hidden',
      padding: '100px 0',
      background: 'linear-gradient(135deg, #2920deff 0%, #0daef3ff 100%)',
      color: '#fff'
    },

    // Animated background layer
    animatedBackground: {
      position: 'absolute',
      inset: 0,
      background:
        'radial-gradient(circle at 50% 120%, rgba(236,72,153,0.4), transparent 50%)',
      animation: 'glow 6s ease-in-out infinite alternate',
      zIndex: 1
    },

    container: {
      position: 'relative',
      zIndex: 2,
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 16px',
      textAlign: 'center',
      '@media (min-width: 640px)': {
        padding: '0 24px'
      }
    },

    contentWrapper: {
      maxWidth: '800px',
      margin: '0 auto',
      display: 'flex',
      flexDirection: 'column',
      gap: '24px',
      alignItems: 'center',
      animation: 'fadeIn 0.8s ease-out'
    },

    title: {
      fontSize: '2.5rem',
      fontWeight: 700,
      lineHeight: 1.2,
      color: '#fff',
      '@media (min-width: 768px)': {
        fontSize: '3.5rem'
      }
    },

    subtitle: {
      fontSize: '1.25rem',
      color: 'rgba(255,255,255,0.9)',
      maxWidth: '650px',
      marginBottom: '32px',
      '@media (min-width: 768px)': {
        fontSize: '1.5rem'
      }
    },

    // Card box
    card: {
      backgroundColor: '#ffffff',
      backdropFilter: 'blur(10px)',
      borderRadius: '20px',
      padding: '32px',
      border: '1px solid rgba(255,255,255,0.2)',
      boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
      maxWidth: '490px',
      width: '100%',
      margin: '0 auto',
      display: 'flex',
      flexDirection: 'column',
      gap: '24px',
      animation: 'fadeIn 1s ease-out'
    },

    checkbox: {
      color: '#1D2530',
      '&.Mui-checked': {
        color: '#2920deff'
      }
    },

    termsLabel: {
      color: '#1D2530',
      lineHeight: 1.6,
      fontSize: '0.9rem'
    },

    termsLink: {
      fontWeight: 600,
      color: '#4f46e5',
      '&:hover': {
        color: '#38bdf8'
      }
    },

    ctaButton: {
      fontWeight: 600,
      fontSize: '1rem',
      padding: '14px 24px',
      borderRadius: '12px',
      background: 'linear-gradient(135deg, #4f46e5 0%, #38bdf8 100%)',
      transition: 'all 0.3s ease',
      '&:hover': {
        background: 'linear-gradient(135deg, #4f46e5 0%, #38bdf8 100%)',
        transform: 'translateY(-2px)',
        boxShadow: '0 8px 20px rgba(255,255,255,0.2)'
      },
      '&.Mui-disabled': {
        opacity: 0.5
      }
    },

    arrowIcon: {
      transition: 'transform 0.3s ease',
      '.MuiButton-root:hover &': {
        transform: 'translateX(4px)'
      }
    },

    securityNote: {
      color: '#1D2530',
      textAlign: 'center'
    },

    // Keyframes
    '@keyframes fadeIn': {
      '0%': { opacity: 0, transform: 'translateY(20px)' },
      '100%': { opacity: 1, transform: 'translateY(0)' }
    },

    '@keyframes glow': {
      '0%': { opacity: 0.7, transform: 'scale(1)' },
      '100%': { opacity: 1, transform: 'scale(1.1)' }
    }
  };
};

export default getStyles;
